var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"result"}},[_c('div',{staticClass:"searchArea"},[_c('div',{staticClass:"searchBar"},[_c('SearchBar')],1)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContent"},[_c('p',[_vm._v(" result ")])])
}]

export { render, staticRenderFns }